import { useEffect } from "react";
import { useNavigate } from "react-router";

import { readAppMessage } from "../../../screens/utils/hybridAppHelpers";

// Native sends full URLs (nav stack entries, notification links); React Router
// treats "https://..." as a literal pathname, so reduce same-origin URLs to a path.
function toRouterPath(path) {
  let url;
  try {
    url = new URL(path, window.location.href);
  } catch {
    return null;
  }
  if (url.origin !== window.location.origin) {
    return null;
  }
  return url.pathname + url.search + url.hash;
}

export default function NativeNavigationListenerWrapper({ children }) {
  const navigate = useNavigate();

  useEffect(() => {
    const handleMessage = (event) => {
      const data = readAppMessage(event);
      if (data?.type === "navigate" && data.path) {
        const routerPath = toRouterPath(data.path);
        if (routerPath) {
          navigate(routerPath);
        }
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [navigate]);

  return <>{children}</>;
}
